// extracted by mini-css-extract-plugin
module.exports = {"textBox":"styles_textBox__2AyEd","editor":"styles_editor__2YLdw","error":"styles_error__1o9Ds","btnAdd":"styles_btnAdd__GdVtQ"};